var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1744,
    height: 1378,
    viewBox: "0 0 1744 1378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1202 1145.91C889.822 1386.15 405.159 1433.93 183.924 1314.41C-23.667 1202.27 -47.8632 1003.72 73.4273 804.625C234.296 540.596 70.9354 334.512 241.476 132.238C356.895 -4.63598 806.158 -77.307 1144.84 127.906C1478.47 330.055 1642.81 806.661 1201.97 1145.92L1202 1145.91Z",
    fill: "#EADEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1727.88 522.364C1700.08 243.029 1472.7 39.6619 1288.85 46.892C1116.36 53.6774 991.145 185.792 942.041 369.22C876.934 612.457 674.419 701.293 649.357 904.138C632.4 1041.45 827.086 1250.07 1121.19 1223.2C1410.89 1196.83 1767.17 916.855 1727.88 522.364Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1740.07 617.992C1765.81 332.04 1597.12 95.1885 1429.36 77.0402C1271.99 60.0042 1134.61 176.119 1056.76 354.534C953.501 591.17 754.028 652.76 694.367 854.2C654.012 990.522 792.182 1228.16 1063.26 1241.77C1330.23 1255.2 1703.69 1021.75 1740.07 617.992Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6b175996f57f4cb89ca814c5014f25db.svg";
export { ForwardRef as ReactComponent };